import * as React from "react";

function SvgSap(props, ref) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      viewBox="0 0 92 45"
      {...{ ...props, ref }}
    >
      <linearGradient
        id="SAP_svg__a"
        gradientUnits="userSpaceOnUse"
        x1={45.483}
        x2={45.483}
        y2={45.001}
      >
        <stop offset={0} stopColor="#00AEEF" />
        <stop offset={0.212} stopColor="#0097DC" />
        <stop offset={0.519} stopColor="#007CC5" />
        <stop offset={0.792} stopColor="#006CB8" />
        <stop offset={1} stopColor="#0066B3" />
      </linearGradient>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="url(#SAP_svg__a)"
        d="M0 45h45.974L90.966 0H0v45"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#fff"
        d="M53.984 9H45l.03 21.13-7.823-21.137H29.45l-6.678 17.653c-.71-4.492-5.354-6.042-9.008-7.203-2.413-.775-4.974-1.915-4.948-3.175.02-1.034 1.37-1.993 4.053-1.85 1.8.097 3.39.242 6.553 1.77l3.11-5.42C19.648 9.3 15.66 8.373 12.39 8.37h-.02c-3.813 0-6.988 1.235-8.956 3.27-1.372 1.42-2.112 3.226-2.142 5.223-.05 2.748.957 4.696 3.073 6.253 1.788 1.31 4.075 2.16 6.09 2.784 2.485.77 4.515 1.44 4.49 2.866a2.112 2.112 0 01-.59 1.398c-.62.64-1.57.88-2.885.906-2.537.054-4.417-.345-7.413-2.116l-2.767 5.49C4.263 36.146 7.44 37 11.05 37l.812-.006c3.142-.057 5.692-.81 7.718-2.44.116-.093.22-.187.328-.282l-.34 1.752 7.58-.024 1.36-3.482c1.43.488 3.056.758 4.782.758 1.682 0 3.264-.256 4.667-.716l.948 3.44 13.6.013.033-7.938h2.894c6.995 0 11.13-3.56 11.13-9.53C66.56 11.896 62.54 9 53.984 9zM33.29 27.062a8.128 8.128 0 01-2.868-.502l2.836-8.955h.055l2.79 8.98c-.84.3-1.797.477-2.814.477zm21.22-5.145h-1.974V14.7h1.975c2.63 0 4.73.876 4.73 3.562-.002 2.78-2.1 3.655-4.73 3.655"
      />
      <path fill="none" d="M0 0h92v45H0z" />
    </svg>
  );
}

export default React.forwardRef(SvgSap);
